var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img-content',{attrs:{"path-img":this.pathImgComputed,"change":false}}),(_vm.pathImgId)?_c('change-file',{model:{value:(_vm.pathImg),callback:function ($$v) {_vm.pathImg=$$v},expression:"pathImg"}}):_vm._e(),_c('v-btn',{on:{"click":_vm.saveChanges}},[_vm._v("Сохранить изменения")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }